import React from 'react';

import { TClientsTableItem } from 'types/state';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { formatDate } from 'utils/formatDate';
import { TableTr, TableTd } from 'design/table';

type Props = {
  item: TClientsTableItem;
  active: boolean;
  onClick(id: number): void;
};

export const ClientsTableItem = (props: Props) => {
  const { item, active, onClick } = props;

  const { prodStackManager, shared: sharedDictionary } = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(item.id);
  }, [onClick, item.id]);

  const updatedOnText = item.updatedOn
    ? formatDate(item.updatedOn, 'DD.MM.YY')
    : '-';

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={`${item.id}`} />
      <TableTd text={item.company} />
      <TableTd text={item.fullName} />
      <TableTd text={item.email} />
      <TableTd text={item.position} />
      <TableTd
        text={
          item.orgStaffCount
            ? prodStackManager.clientInfoForm.staffCountText(item.orgStaffCount)
            : '-'
        }
      />
      <TableTd text={sharedDictionary.moneyAmountText(item.balance, 'USD')} />
      <TableTd text={item.prodStack || '-'} />
      <TableTd text={item.demoStack || '-'} />
      <TableTd text={updatedOnText} />
    </TableTr>
  );
};
